export const forgotPassword = {
    title: 'パスワードを忘れ',
    content: '登録したメールアドレスを入力してください',
    button: '送信',
    titleSwal: 'パスワードのリセットリンクが送信されました',
    contentSwal: 'メールを確認し、パスワードをリセットするリンクを確認してください',
};
